import { render, staticRenderFns } from "./FormModuleForm.vue?vue&type=template&id=c77a5f48&"
import script from "./FormModuleForm.vue?vue&type=script&lang=js&"
export * from "./FormModuleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports